export const contact = {
    phone: '+33 06 64 53 75 00',
    email: 'contact@immodefi.fr'
}